
import React from 'react';

export const Logo: React.FC<{ className?: string }> = ({ className = "w-10 h-10" }) => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Driver Score Logo"
  >
    {/* Background Gradient */}
    <rect width="100" height="100" rx="22" fill="url(#ds_gradient)" />
    
    {/* Gauge Track */}
    <path
      d="M20 70 A 35 35 0 1 1 80 70"
      stroke="rgba(255,255,255,0.3)"
      strokeWidth="8"
      strokeLinecap="round"
    />
    
    {/* Active Gauge Section (Performance) */}
    <path
      d="M20 70 A 35 35 0 0 1 50 35"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
    />

    {/* Needle / Success Arrow */}
    <path
      d="M50 70 L72 42"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
    />
    
    {/* Center Pivot */}
    <circle cx="50" cy="70" r="6" fill="white" />

    {/* Gradient Definition */}
    <defs>
      <linearGradient
        id="ds_gradient"
        x1="0"
        y1="0"
        x2="100"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#f97316" /> {/* Orange 500 */}
        <stop offset="1" stopColor="#c2410c" /> {/* Orange 700 */}
      </linearGradient>
    </defs>
  </svg>
);
